export const WEBSITE_BASE_URL = 'https://new.mindcloud.co';
export const LEGACY_WEBSITE_BASE_URL = 'https://mindcloud.co';

export const buildWebsiteUrl = (path = '/') => {
  const rawPath = String(path || '/');
  const normalizedPath = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;

  return `${WEBSITE_BASE_URL}${normalizedPath}`;
};
